module.exports = __webpack_public_path__ + "img/gis3_on.05e2e4a6.png";